export const mapRoleToKey = (role: string) => {
  switch (role?.toLowerCase()) {
    case 'technician':
      return 'app.user-form.technician';
    case 'standard-technician':
      return 'app.user-form.standard-technician';
    case 'guest-technician':
      return 'app.user-form.guest-technician';
    default:
      return role;
  }
};

export const mapCommodityToKey = (commodity: string) => {
  switch (commodity?.toLowerCase()) {
    case 'power':
      return 'overview.details-data.data-rows.power';
    case 'gas':
      return 'overview.details-data.data-rows.gas';
    case 'water':
      return 'overview.details-data.data-rows.water';
    case 'heating':
      return 'overview.details-data.data-rows.heating';
    default:
      return commodity;
  }
};
